import { NotFoundComponent } from './components/not-found/not-found.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { QCInspectorGuard } from '../shared/guards/qcinspector.guard';
import { FeatureCanActivate } from '../shared/standalone-packages/ecap3/core';
import { Routes } from '@angular/router';
import { AppAutomationReportComponent } from '../app-automation-report/components/app-automation-report.component';

const authFailedRedirection: any = [
    {
        role: 'appuser',
        loggedInredirectTo: '/mailbox',
        loggedOutredirectTo: '/login'
    }
];

export const routes: Routes = [
    {
        path: 'automation-report',
        pathMatch: 'full',
        component: AppAutomationReportComponent,
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: true,
            isPublic: false,
            requiredFeature: 'dashboard',
            authFailRedirection: authFailedRedirection,
            breadcrumb: 'Automation Report',
            breadcrumbType: 'link'
        }
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
        data: {
            isFullScreen: true,
            requiredFeature: 'login'
        }
    },
    {
        path: 'login',
        loadChildren: () => import('../app-login/app-login.module').then(m => m.AppLoginModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: true,
            requiredFeature: 'login',
            authFailRedirection: authFailedRedirection,
            isPublic: true
        }
    },
    {
        path: 'dashboard',
        loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'dashboard',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Dashboard',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'users',
        loadChildren: () =>
            import('../app-user-management/app-user-management.module').then(m => m.AppUserManagementModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'PCX.Navigation',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Users',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'mailbox',
        loadChildren: () => import('../app-mail-box/app-mail-box.module').then(m => m.AppMailBoxModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'mail-box',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Mailbox',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'cases/create-case/:mailId',
        // path: 'mailbox/create-case',
        loadChildren: () => import('../app-create-case/app-create-case.module').then(m => m.AppCreateCaseModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'mail-box',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Create Case',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'cases/case-details/:caseId',
        loadChildren: () => import('../case-details/case-details.module').then(m => m.CaseDetailsModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'mail-box',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Case Details',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'account/activate/:id/:lang',
        loadChildren: () =>
            import('../app-account-activate/app-account-activate.module').then(m => m.AppAccountActivateModule),
        // canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: true,
            requiredFeature: 'account',
            // authFailRedirection: authFailedRedirection,
            breadcrumb: 'Account'
        }
    },
    {
        path: 'profile',
        loadChildren: () => import('../app-profile/app-profile.module').then(m => m.AppProfileModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'profile',
            authFailRedirection: authFailedRedirection,
            breadcrumb: 'Profile',
            isTranslate: true,
            isPublic: false,
            breadcrumbType: 'link',
            isHide: false
        }
    },
    {
        path: 'cases',
        loadChildren: () => import('../app-cases/app-cases.module').then(m => m.AppCasesModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'cases',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Cases',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'jarowa',
        loadChildren: () => import('../app-jarowa/app-jarowa.module').then(m => m.AppJarowaModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'jarowa-integrator',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Jarowa',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'quality-check',
        loadChildren: () => import('../app-quality-check/app-quality-check.module').then(m => m.AppQualityCheckModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'quality-check-list',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Quality Check',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'master-data',
        loadChildren: () => import('../app-master-data/app-master-data.module').then(m => m.AppMasterDataModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'master-data',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Master-data',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: 'case-center',
        loadChildren: () => import('../app-upload-cases/app-upload-cases.module').then(m => m.AppUploadCasesModule),
        canActivate: [FeatureCanActivate],
        data: {
            isFullScreen: false,
            requiredFeature: 'up-ipex-cases',
            authFailRedirection: authFailedRedirection,
            isPublic: false,
            breadcrumb: 'Cases',
            isHide: false,
            breadcrumbType: 'link'
        }
    },
    {
        path: '401',
        component: UnauthorizedComponent,
        data: {
            isFullScreen: false,
            isPublic: false
        }
    },
    {
        path: '404',
        component: NotFoundComponent,
        data: {
            isFullScreen: false,
            isPublic: false
        }
    },
    {
        path: '**',
        redirectTo: '/404',
        data: {
            isFullScreen: false,
            isPublic: false
        }
    }
];
